import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import RegisterAnlageSmallCard from "../anlage/RegisterAnlageSmallCard";
import Validator from "../../services/Validator";

const ElvRegisterComponent = ({ setStep, data, setData }) => {

    const VALIDATOR = new Validator();
    const [errors, setErrors] = useState({});
    

    const nextBtnHandler = () => {
        var tmpErrors = {};

        data.anlagen.forEach(anlage => {
            if (anlage.register === undefined) tmpErrors.registerDate = true;
            if (anlage.registerDate === undefined) tmpErrors.registerDate = true;
            if (anlage.register === true && !VALIDATOR.dateValid(anlage.registerDate)) tmpErrors.registerDate = true;
        });

        if (Object.keys(tmpErrors).length > 0) {
            return setErrors(tmpErrors);
        }

        setStep(8);
    };


    return (
        <>
            <h5 className="text-energo">{data.anlagen.length > 1? "Anlagen": "Anlage"} anmelden</h5>
            <Row className="mt-3">
                {data.anlagen && data.anlagen.length > 0?
                    data.anlagen.map(anlage => (
                        <Col xs="12" className="mb-3" key={`registerColCard-${anlage.id}`}>
                            <RegisterAnlageSmallCard
                                key={`registerAnlageCard-${anlage.id}`}
                                anlage={anlage}
                                errors={errors}
                                data={data}
                                setData={setData}
                                setErrors={setErrors}
                                
                            />
                        </Col>
                    ))
                :null}
            </Row>
            <Row className="mt-3">
                <Col className="text-end">
                    <Button onClick={() => setStep(6)} style={{marginRight: 10}} variant="warning">Zurück</Button>
                    <Button onClick={() => nextBtnHandler()} className="btn-energo">Weiter</Button>
                </Col>
            </Row>
        </>
    )
}
export default ElvRegisterComponent;